<template>
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="類型">
            <el-select
                    v-model="form.type"
                    @change="onTypeChange"
            >
                <el-option
                        v-for="type in types"
                        :key="type.value"
                        :value="type.value"
                        :label="type.label"
                ></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="主旨" prop="subject">
            <el-input
                    v-model="form.subject"
                    placeholder="請輸入主旨"
            ></el-input>
        </el-form-item>
        <el-form-item label="內文">
            <vue-editor
                v-model="form.content" style="font-size: initial;line-height: initial;"
                :editorToolbar="customToolbar"
        ></vue-editor>
            <div v-if="availableTags.length">
                可用的取代標籤:
                {{availableTags}} |
                <small>取代標籤，為@+類型，例如@name代表申請者的姓名，在內文中，放置標籤將會在寄信時取代成對應的文字</small>
           </div>
        </el-form-item>
        <el-button @click="submit" :loading="loading.actions['setting']" type="primary">更新</el-button>
    </el-form>
</template>

<script>
    import {MailTemplateTypes, ReplaceTags} from '../../constants';
    import {createNamespacedHelpers, mapState as mapRootState} from 'vuex';
    import { VueEditor } from "vue2-editor";

    const {mapState, mapActions} = createNamespacedHelpers('setting');
    const defaultForm = {
        subject: '',
        content: '',
        type: MailTemplateTypes.Apply.value,
        isHtml : true,
    };
    export default {
        name: 'MailSetting',
        components:{
            VueEditor
        },
        data: () => ({
            form: {...defaultForm},
            rules: {
                subject: [
                    {required: true, message: '請輸入主旨', trigger: 'blur'}
                ],
                // content:[
                //     {required: true, message: '請輸入信件樣板', trigger: 'blur'}
                // ],

            },
            customToolbar: [
                [{ header: [false, 1, 2, 3, 4, 5, 6] }],
                ["bold", "italic", "underline", "strike"], // toggled buttons
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                ["blockquote", "code-block"],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
                [{ color: [] }, { background: [] }], // dropdown with defaults from theme
                ["clean"] // remove formatting button
            ]
        }),
        methods: {
            ...mapActions({
                getMails: 'getMailsAction',
                updateMail: 'updateMailAction',
            }),
            onTypeChange(){
                const {subject, content} = this.selectedType;
                this.form.subject = subject;
                this.form.content = content;
            },
            async submit() {
                const {form} = this.$refs;
                form.validate(async (valid) => {
                    if (valid) {
                        const {success} = await this.updateMail({...this.form});
                        if(success){
                            this.$message({
                                type: 'success',
                                message: '異動成功'
                            });
                            form.clearValidate();
                        }

                    }
                });
            }
        },
        computed: {
            types() {
                return Object.keys(MailTemplateTypes)
                    .map(k => ({...MailTemplateTypes[k]}))
            },
            ...mapState(['mails']),
            ...mapRootState(['loading']),
            selectedType() {
                return this.mails.find(t => t.type === this.form.type);
            },
            availableTags(){
                return this.types.find(t => t.value === this.form.type).availableReplaces.map(r => {
                    switch (r) {
                        case ReplaceTags.Name:
                            return '@name (姓名)';
                        case ReplaceTags.Url:
                            return '@url (網站連結)';
                        case ReplaceTags.ApplyDate:
                            return '@date (申請日期)';
                        case ReplaceTags.DenyReason:
                            return '@reason (退回原因)';
                        case ReplaceTags.DenyAt:
                            return '@denyAt (退回時間)';
                        case ReplaceTags.FinishAt:
                            return '@finishAt (審核通過時間)';
                        case ReplaceTags.Results:
                            return '@results(抽籤結果)'
                        default:
                            return '';
                    }
                }).join(', ')
            }
        },
        watch: {
            mails(current) {
                const find = current.find(t => t.type === this.form.type);

                if (find) {
                    const {subject, content} = find;
                    this.form.subject = subject;
                    this.form.content = content;
                }
            }
        },
        async created() {
            await this.getMails();
        }
    }
</script>

<style>

</style>